const joinUsImg = "https://drive.google.com/thumbnail?id=14-F7_GWIMXBKg1wiyhaW9Zb2jGdL_PJo";

export default joinUsImg;
